import _JSXStyle from "styled-jsx/style";
import { Card } from '@dhis2-ui/card';
import { InputField } from '@dhis2-ui/input';
import { useConfig } from '@dhis2/app-runtime';
import { colors, spacers, theme } from '@dhis2/ui-constants';
import { IconApps24, IconSettings24 } from '@dhis2/ui-icons';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { joinPath } from './join-path.js';
import i18n from './locales/index.js';
/**
 * Copied from here:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
 */

function escapeRegExpCharacters(text) {
  return text.replace(/[/.*+?^${}()|[\]\\]/g, '\\$&');
}

function Search(_ref) {
  let {
    value,
    onChange
  } = _ref;
  const {
    baseUrl
  } = useConfig();
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-4264724627"
  }, /*#__PURE__*/React.createElement("span", {
    className: "jsx-4264724627"
  }, /*#__PURE__*/React.createElement(InputField, {
    value: value,
    name: "filter",
    placeholder: i18n.t('Search apps'),
    onChange: onChange,
    initialFocus: true
  })), /*#__PURE__*/React.createElement("span", {
    className: "jsx-4264724627"
  }, /*#__PURE__*/React.createElement("a", {
    href: joinPath(baseUrl, 'dhis-web-menu-management'),
    className: "jsx-4264724627"
  }, /*#__PURE__*/React.createElement(IconSettings24, {
    color: colors.grey700
  }))), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4264724627"
  }, ["div.jsx-4264724627{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;height:52px;margin:8px;}", "span.jsx-4264724627{-webkit-flex:1 100%;-ms-flex:1 100%;flex:1 100%;}", "span.jsx-4264724627:last-child{-webkit-flex:1 auto;-ms-flex:1 auto;flex:1 auto;margin:8px;}"]));
}

Search.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

function Item(_ref2) {
  let {
    name,
    path,
    img
  } = _ref2;
  return /*#__PURE__*/React.createElement("a", {
    href: path,
    className: _JSXStyle.dynamic([["1412616027", [theme.primary050]]])
  }, /*#__PURE__*/React.createElement("img", {
    src: img,
    alt: "app logo",
    className: _JSXStyle.dynamic([["1412616027", [theme.primary050]]])
  }), /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["1412616027", [theme.primary050]]])
  }, name), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1412616027",
    dynamic: [theme.primary050]
  }, ["a.__jsx-style-dynamic-selector{display:inline-block;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:96px;margin:8px;border-radius:12px;-webkit-text-decoration:none;text-decoration:none;cursor:pointer;}", "a.__jsx-style-dynamic-selector:hover,a.__jsx-style-dynamic-selector:focus{background-color:".concat(theme.primary050, ";cursor:pointer;}"), "a.__jsx-style-dynamic-selector:hover>div.__jsx-style-dynamic-selector{font-weight:500;cursor:pointer;}", "img.__jsx-style-dynamic-selector{width:48px;height:48px;margin:8px;cursor:pointer;}", "div.__jsx-style-dynamic-selector{overflow-wrap:anywhere;margin-top:14px;color:rgba(0,0,0,0.87);font-size:12px;-webkit-letter-spacing:0.01em;-moz-letter-spacing:0.01em;-ms-letter-spacing:0.01em;letter-spacing:0.01em;line-height:14px;text-align:center;cursor:pointer;}"]));
}

Item.propTypes = {
  img: PropTypes.string,
  name: PropTypes.string,
  path: PropTypes.string
};

function List(_ref3) {
  let {
    apps,
    filter
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-apps-menu-list",
    className: "jsx-2424821176"
  }, apps.filter(_ref4 => {
    let {
      displayName,
      name
    } = _ref4;
    const appName = displayName || name;
    const formattedAppName = appName.toLowerCase();
    const formattedFilter = escapeRegExpCharacters(filter).toLowerCase();
    return filter.length > 0 ? formattedAppName.match(formattedFilter) : true;
  }).map((_ref5, idx) => {
    let {
      displayName,
      name,
      defaultAction,
      icon
    } = _ref5;
    return /*#__PURE__*/React.createElement(Item, {
      key: "app-".concat(name, "-").concat(idx),
      name: displayName || name,
      path: defaultAction,
      img: icon
    });
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2424821176"
  }, ["div.jsx-2424821176{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-align-content:flex-start;-ms-flex-line-pack:start;align-content:flex-start;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;width:30vw;min-width:300px;max-width:560px;min-height:200px;max-height:465px;margin-block-start:0;margin-block-end:8px;margin-inline:8px;overflow:auto;overflow-x:hidden;}"]));
}

List.propTypes = {
  apps: PropTypes.array,
  filter: PropTypes.string
};

const AppMenu = _ref6 => {
  let {
    apps,
    filter,
    onFilterChange
  } = _ref6;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-apps-menu",
    className: "jsx-3826299842"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Search, {
    value: filter,
    onChange: onFilterChange
  }), /*#__PURE__*/React.createElement(List, {
    apps: apps,
    filter: filter
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3826299842"
  }, ["div.jsx-3826299842{z-index:10000;position:absolute;inset-inline-end:-4px;}"]));
};

AppMenu.propTypes = {
  apps: PropTypes.array.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filter: PropTypes.string
};

const Apps = _ref7 => {
  let {
    apps
  } = _ref7;
  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState('');
  const handleVisibilityToggle = useCallback(() => setShow(!show), [show]);
  const handleFilterChange = useCallback(_ref8 => {
    let {
      value
    } = _ref8;
    return setFilter(value);
  }, []);
  const containerEl = useRef(null);
  const onDocClick = useCallback(evt => {
    if (containerEl.current && !containerEl.current.contains(evt.target)) {
      setShow(false);
    }
  }, []);
  useEffect(() => {
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, [onDocClick]);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerEl,
    "data-test": "headerbar-apps",
    className: _JSXStyle.dynamic([["325245423", [spacers.dp4, spacers.dp12]]])
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleVisibilityToggle,
    "data-test": "headerbar-apps-icon",
    className: _JSXStyle.dynamic([["325245423", [spacers.dp4, spacers.dp12]]])
  }, /*#__PURE__*/React.createElement(IconApps24, {
    color: colors.white
  })), show ? /*#__PURE__*/React.createElement(AppMenu, {
    apps: apps,
    filter: filter,
    onFilterChange: handleFilterChange
  }) : null, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "325245423",
    dynamic: [spacers.dp4, spacers.dp12]
  }, ["button.__jsx-style-dynamic-selector{display:block;background:transparent;padding-block-start:".concat(spacers.dp4, ";padding-block-end:0;padding-inline:").concat(spacers.dp12, ";border:0;cursor:pointer;height:100%;}"), "button.__jsx-style-dynamic-selector:focus{outline:2px solid white;outline-offset:-2px;}", "button.__jsx-style-dynamic-selector:focus.__jsx-style-dynamic-selector:not(:focus-visible){outline:none;}", "button.__jsx-style-dynamic-selector:hover{background:#1a557f;}", "button.__jsx-style-dynamic-selector:active{background:#104067;}", "div.__jsx-style-dynamic-selector{position:relative;height:100%;}"]));
};

Apps.propTypes = {
  apps: PropTypes.array.isRequired
};
export default Apps;